import { Component } from "@angular/core";

@Component({
  selector: "app-fields",
  templateUrl: "./fields.component.html",
  styleUrls: ["./fields.component.scss"]
})
export class FieldsComponent {}
